import { useNavigate } from '@tanstack/react-router';
import css from './not-found-page.module.scss';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className={css.root}>
      <h1 className={css.code}>404</h1>
      <p className={css.message}>Page not found</p>
      <button
        className={css.button}
        onClick={() => navigate({ to: '/' })}
        type="button"
      >
        Go to home
      </button>
    </div>
  );
};
